import { render, staticRenderFns } from "./ZBTGoods.vue?vue&type=template&id=d0033c4c&scoped=true&"
import script from "./ZBTGoods.vue?vue&type=script&lang=js&"
export * from "./ZBTGoods.vue?vue&type=script&lang=js&"
import style0 from "./ZBTGoods.vue?vue&type=style&index=0&id=d0033c4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0033c4c",
  null
  
)

export default component.exports